import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/computers',
    },
    {
        name: 'computers',
        path: '/computers',
        component: require('../views/computers/Computers').default,
        children: [
            {
                path: '/',
                name: 'computers.statuses',
                component: require('../views/computers/components/ComputerList').default,
                meta: {
                    showModal: false
                }
            },
            {
                path: 'view/:id',
                name: 'computers.view',
                components: {
                    default: require('../views/computers/components/ComputerList').default,
                    dialog: require('../views/computers/components/ComputerView').default,
                },
                props: {
                    dialog: (route) => ({
                        propItemId: route.params.id,
                    }),
                },
                meta: {
                    showModal: true
                }
            },
        ]
    },
    {
        name: 'gpus',
        path: '/gpus',
        component: require('../views/gpus/Gpus').default,
        children: [
            {
                path: '/',
                name: 'gpus.list',
                component: require('../views/gpus/components/GpuList').default,
                meta: {
                    showModal: false
                }
            },
            {
                path: 'view/:id',
                name: 'gpus.view',
                components: {
                    default: require('../views/gpus/components/GpuList').default,
                    dialog: require('../views/gpus/components/GpuList').default,
                },
                props: {
                    dialog: (route) => ({
                        propItemId: route.params.id,
                    }),
                },
                meta: {
                    showModal: true
                }
            },
        ]
    },
    {
        name: 'service',
        path: '/service',
        component: require('../views/service/Index').default,
        children: [
            {
                path: '/',
                name: 'service.scan',
                component: require('../views/service/components/Scan').default,
                meta: {
                    showModal: false
                }
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
